export default "__VITE_ASSET__yF37YmVH__"